import { IconButton, TextField } from "@mui/material"
import Icons from "../../assets/js/Icons"
import { useState } from "react"

function InputFieldA({
  name,
  type,
  label,
  error,
  success,
  helperText,
  ...rest
}) {
  const [show, setShow] = useState(false)

  return (
    <TextField
      size="small"
      variant="filled"
      varianttype="login"
      name={name || null}
      type={
        (
          type === "password" ?
            show ? "text" : "password" :
            type
        ) || "text"
      }
      label={label || null}
      error={Boolean(helperText?.[name]) || null}
      helperText={helperText?.[name]?.[0] || null}

      slotProps={{
        input: {
          autoComplete: "new-password",
          endAdornment:
            type === "password" ? (<IconButton
              size="small"
              onClick={() => { setShow(!show) }}
            >
              {!show ?
                <Icons.ViewSolid /> :
                <Icons.ViewOffSolid />
              }
            </IconButton>) : null
        }
      }}
      {...rest}
    />
  )
}

export default InputFieldA